import {
    ApplicationMethod,
    BasketCustomisations,
    CustomisationWithIdAndLocation,
    Targets,
} from 'src/components/CustomisationPage/feature/customisation.types';
import { CartItem } from 'src/core/state/cart';
import { BasketItemType } from 'src/components/Basket/BasketContext';

export type CopyParams = {
    subject: BasketCustomisations;
    totalCount: number;
} & Targets;

export const getCopyParams = (
    cartItems: BasketItemType[],
    subjectItemId: number | string,
    customisation: CustomisationWithIdAndLocation,
) => {
    const subjectLocationNames = customisation.location_names;
    const subjectCustomisationMethod = customisation.customisation.type;

    const validTargets: CartItem[] = [];
    const invalidTargets: CartItem[] = [];
    cartItems.forEach((cartItem) => {
        if (String(cartItem.cartItem.id) === String(subjectItemId)) return;

        if (cartItem.customisations.find((item) => item.id === customisation.id)) return false;

        const availableLocations = cartItem.availableLocations.find((loc) => {
            if (loc.method === ApplicationMethod.Both || loc.method === subjectCustomisationMethod) {
                if (subjectLocationNames.indexOf(loc.name) > -1) {
                    return true;
                }
            }
            return false;
        });

        const isUsedLocation = cartItem.customisations.find((customisation) =>
            subjectLocationNames.includes(customisation.location_name),
        );

        const canApplyToThisItem = availableLocations && !isUsedLocation;

        if (canApplyToThisItem) {
            validTargets.push(cartItem.cartItem);
        } else {
            invalidTargets.push(cartItem.cartItem);
        }
    });
    return {
        invalidTargets,
        validTargets,
    };
};
